import React, { useState, useEffect } from "react";
import "./PricingRules.css";

const defaultRules = [
  {
    suffix: "-s",
    label: "Supernatant",
    productForm: "Supernatant 1.0 ml",
    allowProfit: true,
    npPrices: [
      { price: 50, qty: 0, level: "1-Non-Profit" },
      { price: 48, qty: 20, level: "1-Non-Profit" },
      { price: 46, qty: 50, level: "1-Non-Profit" },
      { price: 44, qty: 100, level: "1-Non-Profit" },
    ],
    fpPrices: [
      { price: 35, qty: 0, level: "2-For-Profit" },
      { price: 33, qty: 20, level: "2-For-Profit" },
      { price: 31, qty: 50, level: "2-For-Profit" },
      { price: 29, qty: 100, level: "2-For-Profit" },
    ],
  },
  {
    suffix: "-f",
    label: "Frozen Cells",
    productForm: "Frozen Cells 1 vial",
    allowProfit: false,
    //npPrices: Array(4).fill({ price: 0, qty: 0, level: "1-Non-Profit" }),
    npPrices: Array.from({ length: 4 }, () => ({ price: 0, qty: 0, level: "1-Non-Profit" })),
    fpPrices: Array(4).fill({ price: 0, qty: 0, level: "2-For-Profit" }),
  },
  {
    suffix: "-g",
    label: "Growing Cells",
    productForm: "Growing Cells 1 vial",
    allowProfit: false,
    //npPrices: Array(4).fill({ price: 0, qty: 0, level: "1-Non-Profit" }),
    npPrices: Array.from({ length: 4 }, () => ({ price: 0, qty: 0, level: "1-Non-Profit" })),
    fpPrices: Array(4).fill({ price: 0, qty: 0, level: "2-For-Profit" }),
  },
  {
    suffix: "-x",
    label: "Purified Antibody",
    productForm: "Purified Antibody",
    allowProfit: true,
    //npPrices: Array(4).fill({ price: 0, qty: 0, level: "1-Non-Profit" }),
    npPrices: Array.from({ length: 4 }, () => ({ price: 0, qty: 0, level: "1-Non-Profit" })),
    fpPrices: Array(4).fill({ price: 0, qty: 0, level: "2-For-Profit" }),
  },
  {
    suffix: "-p",
    label: "Polyclonal Sera",
    productForm: "Polyclonal Sera",
    allowProfit: true,
    npPrices: [
      { price: 50, qty: 0, level: "1-Non-Profit" },
      { price: 48, qty: 20, level: "1-Non-Profit" },
      { price: 46, qty: 50, level: "1-Non-Profit" },
      { price: 44, qty: 100, level: "1-Non-Profit" },
    ],
    fpPrices: Array(4).fill({ price: 0, qty: 0, level: "2-For-Profit" }),
  },
];

export default function PricingRules({ initialRules, onClose, onRulesChange }) {
  const [tempRules, setTempRules] = useState(initialRules || defaultRules);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (initialRules && initialRules.length > 0) {
        setTempRules(initialRules);
    }
    }, [initialRules]);

  const handleChange = (ruleIndex, type, tierIndex, field, value) => {
    const updated = [...tempRules];
    updated[ruleIndex][type][tierIndex][field] =
      field === "price" || field === "qty" ? Number(value) : value;
    setTempRules(updated);
  };

  const handleFieldChange = (ruleIndex, field, value) => {
    const updated = [...tempRules];
    updated[ruleIndex][field] = value;
    setTempRules(updated);
  };

  const handleSave = () => {
    setEditMode(false);
    if (onRulesChange) onRulesChange(tempRules);
  };

  const handleCancel = () => {
    setEditMode(false);
    setTempRules(initialRules || defaultRules);
  };

  return (
    <div className="pricing-modal-overlay">
      <div className="pricing-modal">
        <div className="pricing-header">
          <h2>Pricing Configuration</h2>
          <button className="close-btn" onClick={onClose}>✖</button>
        </div>

        {!editMode ? (
          <div style={{ padding: "16px 28px", background: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
            <button className="edit-btn" onClick={() => setEditMode(true)}>Edit</button>
          </div>
        ) : (
          <div className="action-buttons">
            <button className="save-btn" onClick={handleSave}>Save</button>
            <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
          </div>
        )}

        <div className="pricing-table-container">
          <table className="pricing-table">
            <thead>
              <tr className="group-header">
                <th rowSpan="2">Suffix</th>
                <th rowSpan="2">Product Type</th>
                <th rowSpan="2">Product Form</th>
                <th colSpan="12">Non-Profit Pricing</th>
                <th colSpan="12">For-Profit Pricing</th>
                <th rowSpan="2">Allow Profit</th>
              </tr>
              <tr>
                {Array(8).fill(0).map((_, i) => (
                  <React.Fragment key={i}>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Level</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>

            <tbody>
              {tempRules.map((rule, i) => (
                <tr key={rule.suffix}>
                  <td>{rule.suffix}</td>
                  <td>{rule.label}</td>
                  <td>{rule.productForm}</td>

                  {rule.npPrices.map((tier, t) => (
                    <React.Fragment key={`np-${t}`}>
                      <td>
                        {editMode ? (
                          <input
                            type="number"
                            value={tier.price}
                            onChange={(e) => handleChange(i, "npPrices", t, "price", e.target.value)}
                          />
                        ) : tier.price}
                      </td>
                      <td>
                        {editMode ? (
                          <input
                            type="number"
                            value={tier.qty}
                            onChange={(e) => handleChange(i, "npPrices", t, "qty", e.target.value)}
                          />
                        ) : tier.qty}
                      </td>
                      <td>{tier.level}</td>
                    </React.Fragment>
                  ))}

                  {rule.fpPrices.map((tier, t) => (
                    <React.Fragment key={`fp-${t}`}>
                      <td>
                        {editMode ? (
                          <input
                            type="number"
                            value={tier.price}
                            onChange={(e) => handleChange(i, "fpPrices", t, "price", e.target.value)}
                          />
                        ) : tier.price}
                      </td>
                      <td>
                        {editMode ? (
                          <input
                            type="number"
                            value={tier.qty}
                            onChange={(e) => handleChange(i, "fpPrices", t, "qty", e.target.value)}
                          />
                        ) : tier.qty}
                      </td>
                      <td>{tier.level}</td>
                    </React.Fragment>
                  ))}

                  <td>
                    {editMode ? (
                      <select
                        value={rule.allowProfit}
                        onChange={(e) => handleFieldChange(i, "allowProfit", e.target.value === "true")}
                      >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    ) : rule.allowProfit ? "Yes" : "No"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export { defaultRules };
